<template>
  <div class="campaign-report">
    <!-- 页面标题 -->
<!--    <div class="page-header">-->
<!--      <h2>TikTok 推广系列完整报表</h2>-->
<!--      <div class="header-actions">-->
<!--        <el-button-->
<!--            type="primary"-->
<!--            icon="el-icon-refresh"-->
<!--            :loading="loading"-->
<!--            @click="handleQuery"-->
<!--        >-->
<!--          刷新数据-->
<!--        </el-button>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 查询条件 -->
    <el-card shadow="never" class="filter-card">

        <el-form :model="queryForm" :rules="rules" ref="queryForm" inline>
          <el-form-item label="广告主" prop="advertiserId">
            <el-select
                v-model="queryForm.advertiserId"
                placeholder="请选择广告主"
                filterable              style="width: 240px"
            >
              <el-option
                  v-for="item in advertiserList"
                  :key="item.advertiser_id"
                  :label="item.advertiser_name.replace('-SUNNY-SINO-TT', '')+' | '+item.advertiser_id"
                  :value="item.advertiser_id"
              />
            </el-select>
          </el-form-item>

        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
              v-model="queryForm.startDate"
              type="date"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              style="width: 160px"
          />
        </el-form-item>

        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
              v-model="queryForm.endDate"
              type="date"
              placeholder="选择结束日期"
              value-format="yyyy-MM-dd"
              style="width: 160px"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleQuery" :loading="loading">
            查询
          </el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button
              type="success"
              @click="exportData"
              :disabled="tableData.length === 0"
          >
            导出数据
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 统计信息 -->
    <el-row :gutter="12" class="stats-row">
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-item">
            <div class="stat-label">推广系列总数</div>
            <div class="stat-value">{{ pagination.total }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-item">
            <div class="stat-label">收入 / 消耗</div>
            <div class="stat-value">${{ formatMoney(statsData.totalRevenue) }} / ${{ formatMoney(statsData.totalSpend) }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-item">
            <div class="stat-label">总展示量</div>
            <div class="stat-value">{{ formatNumber(statsData.totalImpressions) }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-item">
            <div class="stat-label">总转化数</div>
            <div class="stat-value">{{ formatNumber(statsData.totalConversions) }}</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-card shadow="never">
      <el-table
          :data="tableData"
          v-loading="loading"
          stripe
          max-height="700"
          style="width: 100%"
          row-key="campaignId"
          @expand-change="handleExpandChange"
      >

        <el-table-column type="expand" width="75" label="广告组" align="center">
          <template slot-scope="scope">
            <i :class="scope.row._expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
          </template>
        </el-table-column>

        <!-- 推广系列基础信息 -->
        <el-table-column label="推广系列信息" min-width="250">
          <template slot-scope="scope">
            <div class="campaign-info">
              <div class="campaign-name">{{ scope.row.campaignName }}</div>
              <div class="campaign-id">{{ scope.row.campaignId }}</div>
<!--              <div class="campaign-type">{{ getObjectiveTypeText(scope.row.objectiveType) }}</div>-->
            </div>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag effect="plain"  :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="每日预算" width="120" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.budget">
              ${{ formatMoney(scope.row.budget) }}
            </div>
            <div v-else class="text-muted">-</div>
          </template>
        </el-table-column>

        <!-- 报表指标 -->
        <el-table-column label="消耗" width="120" align="center" >
          <template slot-scope="scope">
            <span class="metric-value spend">${{ formatMoney(scope.row.spend) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="展示次数" width="120" align="center" >
          <template slot-scope="scope">
            <span class="metric-value impressions">{{ formatNumber(scope.row.impressions) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="点击次数" width="120" align="center" >
          <template slot-scope="scope">
            <span class="metric-value clicks">{{ formatNumber(scope.row.clicks) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="点击率" width="100" align="center" >
          <template slot-scope="scope">
            <span class="metric-value ctr">{{ calculateCTR(scope.row.clicks, scope.row.impressions) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="转化数" width="100" align="center" >
          <template slot-scope="scope">
            <span class="metric-value conversion">{{ formatNumber(scope.row.conversion) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="首日ROAS" width="100" align="center" >
          <template slot-scope="scope">
            <span class="metric-value roas">{{ scope.row.roas ? scope.row.roas.toFixed(2) : '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="ROAS13" width="100" align="center" >
          <template slot-scope="scope">
            <span class="metric-value roas">{{ scope.row.roasDay13 ? scope.row.roasDay13.toFixed(2) : '-' }}</span>
          </template>
        </el-table-column>

<!--        <el-table-column label="CPA" width="100" align="right" sortable>-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.cpa ? '¥' + scope.row.cpa.toFixed(2) : '-' }}-->
<!--          </template>-->
<!--        </el-table-column>-->


        <!-- 展开行：广告组列表 -->
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
            <div v-if="scope.row.adGroups && scope.row.adGroups.length > 0" class="adgroups-expand">
              <div class="expand-title">广告组列表 (共 {{ scope.row.adGroups.length }} 个)</div>
              <el-table :data="scope.row.adGroups" size="small" border class="adgroups-table">
                <el-table-column prop="adgroupName" label="广告组名称" min-width="180">
                  <template slot-scope="ag">
                    <span class="adgroup-name-link">{{ ag.row.adgroupName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="adgroupId" label="广告组ID" width="150">
                  <template slot-scope="ag">
                    <span class="text-small">{{ ag.row.adgroupId }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="optimizationGoal" label="优化目标" width="100">
                  <template slot-scope="ag">
                    {{ getOptimizationGoalText(ag.row.optimizationGoal) }}
                  </template>
                </el-table-column>
                <el-table-column prop="deepBidType" label="深度出价" width="100">
                  <template slot-scope="ag">
                    {{ getDeepBidTypeText(ag.row.deepBidType) }}
                  </template>
                </el-table-column>
                <el-table-column prop="spend" label="消耗" width="120" align="right">
                  <template slot-scope="ag">
                    ${{ formatMoney(ag.row.spend) }}
                  </template>
                </el-table-column>
                <el-table-column prop="impressions" label="展示量" width="100" align="right">
                  <template slot-scope="ag">
                    {{ formatNumber(ag.row.impressions) }}
                  </template>
                </el-table-column>
                <el-table-column prop="clicks" label="点击量" width="100" align="right">
                  <template slot-scope="ag">
                    {{ formatNumber(ag.row.clicks) }}
                  </template>
                </el-table-column>
                <el-table-column prop="ctr" label="点击率" width="80" align="right">
                  <template slot-scope="ag">
                    {{ calculateCTR(ag.row.clicks, ag.row.impressions) }}
                  </template>
                </el-table-column>
                <el-table-column prop="conversion" label="转化数" width="80" align="right">
                  <template slot-scope="ag">
                    {{ formatNumber(ag.row.conversion) }}
                  </template>
                </el-table-column>
                <el-table-column prop="roas" label="ROAS" width="80" align="right">
                  <template slot-scope="ag">
                    {{ ag.row.roas ? ag.row.roas.toFixed(2) : '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="roasDay13" label="ROAS13" width="90" align="right">
                  <template slot-scope="ag">
                    {{ ag.row.roasDay13 ? ag.row.roasDay13.toFixed(2) : '-' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else class="no-adgroups">
              <i class="el-icon-warning"></i> 该推广系列暂无广告组
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          style="margin-top: 20px; text-align: right"
      />
    </el-card>
  </div>
</template>

<script>
import {getCampaignsComplete, getCampaignsCompleteWithAdgroups} from '@/api/smartPlus'
import {advertiserApi} from "@/api/advertiserApi";

export default {
  name: 'CampaignReport',
  data() {
    return {
      loading: false,
      advertiserList: [],
      queryForm: {
        advertiserId: '',
        startDate: this.getDefaultStartDate(),
        endDate: this.getDefaultEndDate()
      },
      rules: {

        startDate: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ]
      },
      tableData: [],
      statsData: {
        totalSpend: 0,
        totalImpressions: 0,
        totalConversions: 0,
        totalRevenue: 0
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },  created() {
    this.loadAdvertiserList()
  },
  computed: {
  },
  methods: {
    loadAdvertiserList() {
      advertiserApi.getList().then(response => {
        if (response.code === 0 || response.success) {
          this.advertiserList = response.data?.list || []
        } else {
          console.error('加载广告主列表失败:', response.message)
        }
      }).catch(error => {
        console.error('请求广告主列表失败:', error)
      })
    },
    // 获取默认开始日期（30天前）
    getDefaultStartDate() {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      return this.formatDate(date)
    },

    // 获取默认结束日期（今天）
    getDefaultEndDate() {
      return this.formatDate(new Date())
    },

    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 查询数据
    handleQuery() {
      this.pagination.page = 1
      this.loadData()
    },

    // 加载数据
    loadData() {
      this.$refs.queryForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const params = {
            advertiserId: this.queryForm.advertiserId,
            startDate: this.queryForm.startDate,
            endDate: this.queryForm.endDate,
            page: this.pagination.page,
            pageSize: this.pagination.pageSize
          }

          getCampaignsCompleteWithAdgroups(params)
              .then(response => {
                if (response.code === 200 && response.data) {
                  this.tableData = response.data.data || []
                  this.pagination.total = response.data.total || 0
                  this.statsData = {
                    totalSpend: response.data.totalSpend || 0,
                    totalImpressions: response.data.totalImpressions || 0,
                    totalConversions: response.data.totalConversions || 0,
                    totalRevenue: response.data.totalRevenue || 0
                  }
                  this.$message.success(`成功获取 ${response.data.total} 个推广系列数据`)
                } else {
                  this.$message.error(response.message || '获取数据失败')
                }
              })
              .catch(error => {
                this.$message.error('请求失败: ' + error.message)
              })
              .finally(() => {
                this.loading = false
              })
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.queryForm.resetFields()
      this.queryForm.startDate = this.getDefaultStartDate()
      this.queryForm.endDate = this.getDefaultEndDate()
      this.tableData = []
      this.pagination.total = 0
    },

    // 导出数据
    exportData() {
      if (this.tableData.length === 0) {
        this.$message.warning('没有数据可导出')
        return
      }

      // 准备导出数据
      const exportData = this.tableData.map(item => ({
        '推广系列ID': item.campaignId,
        '推广系列名称': item.campaignName,
        '营销目标': this.getObjectiveTypeText(item.objectiveType),
        '状态': this.getStatusText(item.status),
        '预算': item.budget || 0,
        '消耗': item.spend || 0,
        '展示次数': item.impressions || 0,
        '点击次数': item.clicks || 0,
        '点击率': item.ctr ? (item.ctr * 100).toFixed(2) + '%' : '0%',
        '转化数': item.conversion || 0,
        'ROAS': item.roas || 0,
        'ROAS13': item.roasDay13 || 0,
        'CPA': item.cpa || 0,
        '首个广告组ID': item.firstAdgroupId || '-',
        '首个广告组名称': item.firstAdgroupName || '-',
        '优化目标': this.getOptimizationGoalText(item.firstAdgroupOptimizationGoal),
        '深度出价类型': this.getDeepBidTypeText(item.firstAdgroupDeepBidType)
      }))

      // 使用简单的 CSV 导出
      this.exportToCSV(exportData, `推广系列报表_${this.queryForm.startDate}_${this.queryForm.endDate}.csv`)
    },

    // 导出为 CSV
    exportToCSV(data, filename) {
      if (!data || data.length === 0) return

      // 获取表头
      const headers = Object.keys(data[0])

      // 构建 CSV 内容
      const csvContent = [
        headers.join(','),
        ...data.map(row =>
            headers.map(header => {
              const value = row[header]
              // 如果值包含逗号或引号，需要转义
              if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
                return `"${value.replace(/"/g, '""')}"`
              }
              return value
            }).join(',')
        )
      ].join('\n')

      // 添加 BOM 以支持中文
      const BOM = '\uFEFF'
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })

      // 创建下载链接
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      this.$message.success('导出成功')
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.page = 1
      this.loadData()
    },

    // 页码改变
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadData()
    },

    // 展开/折叠广告组
    handleExpandChange(row, expanded) {
      row._expanded = expanded
    },

    // 格式化金额
    formatMoney(value) {
      if (!value && value !== 0) return '0.00'
      return Number(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    // 格式化数字
    formatNumber(value) {
      if (!value && value !== 0) return '0'
      return Number(value).toLocaleString()
    },

    // 获取营销目标文本
    getObjectiveTypeText(objectiveType) {
      const map = {
        'CONVERSIONS': '转化',
        'TRAFFIC': '流量',
        'REACH': '覆盖人数',
        'VIDEO_VIEWS': '视频观看',
        'APP_INSTALLS': '应用安装',
        'LEAD_GENERATION': '潜在客户生成',
        'APP_PROMOTION': '应用推广',
        'PRODUCT_SALES': '商品销售',
        'WEBSITE_CONVERSIONS': '网站转化',
        'ENGAGEMENT': '互动'
      }
      return map[objectiveType] || objectiveType
    },

    // 获取状态文本
    getStatusText(status) {
      const map = {
        'CAMPAIGN_STATUS_ENABLE': '启用',
        'CAMPAIGN_STATUS_DISABLE': '暂停',
        'CAMPAIGN_STATUS_DELETE': '已删除',
        'ENABLE': '启用',
        'DISABLE': '暂停',
        'DELETE': '已删除',
        'ADGROUP_STATUS_ENABLE': '启用',
        'ADGROUP_STATUS_DISABLE': '暂停',
        'ADGROUP_STATUS_DELETE': '已删除'
      }
      return map[status] || status
    },

    // 获取状态标签类型
    getStatusType(status) {
      const map = {
        'CAMPAIGN_STATUS_ENABLE': 'success',
        'CAMPAIGN_STATUS_DISABLE': 'warning',
        'CAMPAIGN_STATUS_DELETE': 'danger',
        'ENABLE': 'success',
        'DISABLE': 'warning',
        'DELETE': 'danger',
        'ADGROUP_STATUS_ENABLE': 'success',
        'ADGROUP_STATUS_DISABLE': 'warning',
        'ADGROUP_STATUS_DELETE': 'danger'
      }
      return map[status] || 'info'
    },

    // 获取优化目标文本
    getOptimizationGoalText(goal) {
      if (!goal) return '-'
      const map = {
        'VALUE': '价值',
        'CONVERSION': '转化',
        'CLICK': '点击',
        'IMPRESSION': '展示',
        'REACH': '覆盖',
        'VIDEO_WATCH_TIME': '视频观看时长',
        'COMPLETE_PAYMENT': '完成支付',
        'ADD_TO_CART': '加入购物车',
        'INSTALL_APP': '安装应用',
        'REGISTER': '注册',
        'LOGIN': '登录'
      }
      return map[goal] || goal
    },

    // 获取深度出价类型文本
    getDeepBidTypeText(deepBidType) {
      if (!deepBidType) return '-'
      const map = {
        'VOLUME': '最大转化量',
        'VALUE': '最大转化价值',
        'VO_HIGHEST_VALUE': '最高价值',
        'BID': '最低成本',
        'ROI_GOAL': 'ROI系数'
      }
      return map[deepBidType] || deepBidType
    },

    // 计算点击率
    calculateCTR(clicks, impressions) {
      if (!impressions || impressions === 0) return '-'
      const ctr = (clicks / impressions) * 100
      return ctr.toFixed(2) + '%'
    }
  }
}
</script>

<style scoped>
.campaign-report {
  padding: 24px;
  background: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.page-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  letter-spacing: 0.5px;
}

.filter-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.filter-card >>> .el-card__body {
  padding: 12px 20px;
}

.filter-card >>> .el-form--inline .el-form-item {
  margin-right: 16px;
  margin-bottom: 0;
}

.filter-card >>> .el-form-item__label {
  font-size: 13px;
  line-height: 32px;
}

.stats-row {
  margin-bottom: 16px;
}

.stat-card {
  text-align: center;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-card:nth-child(2),
.stat-card:nth-child(3),
.stat-card:nth-child(4) {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.stat-card:nth-child(2):hover,
.stat-card:nth-child(3):hover,
.stat-card:nth-child(4):hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-item {
  padding: 8px 0;
}

.stat-label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
  font-weight: 500;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

/* 表格样式 */
.el-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.el-table {
  border-radius: 8px;
  overflow: hidden;
}

.el-table th {
  background: #f8f9fa !important;
  color: #606266;
  font-weight: 600;
  font-size: 13px;
}

.el-table td {
  font-size: 13px;
  color: #303133;
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f5f7fa;
}

.campaign-info {
  line-height: 1.4;
}

.campaign-name {
  font-weight: 500;
  color: #303133;
  margin-bottom: 2px;
  font-size: 13px;
}

.campaign-id {
  font-size: 11px;
  color: #909399;
}

.campaign-type {
  font-size: 12px;
  color: #606266;
  margin-top: 6px;
}

.text-muted {
  color: #C0C4CC;
}

.adgroups-expand {
  padding: 16px 24px;
  background: #fafafa;
  border-radius: 4px;
  margin: 8px;
}

.expand-title {
  font-weight: 500;
  margin-bottom: 12px;
  color: #303133;
  font-size: 13px;
}

.adgroups-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.adgroup-name-link {
  font-weight: 500;
  color: #409EFF;
}

.text-small {
  font-size: 12px;
  color: #909399;
}

.no-adgroups {
  padding: 24px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

.no-adgroups i {
  margin-right: 6px;
  font-size: 16px;
}

/* 指标数值样式 */
.metric-value {
  display: inline-block;
  font-weight: 500;
  font-size: 13px;
}

.metric-value.spend {
  color: #F56C6C;
}

.metric-value.impressions {
  color: #409EFF;
}

.metric-value.clicks {
  color: #67C23A;
}

.metric-value.ctr {
  color: #E6A23C;
}

.metric-value.conversion {
  color: #909399;
}

.metric-value.roas {
  color: #667eea;
}

/* 分页样式 */
.el-pagination {
  padding: 16px 0;
}

/* 按钮样式优化 */
.el-button {
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.el-button--primary {
  background: #409EFF;
  border-color: #409EFF;
}

.el-button--primary:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.el-button--success {
  background: #67C23A;
  border-color: #67C23A;
  color: white;
}

.el-button--success:hover {
  background: #85ce61;
  border-color: #85ce61;
}

/* 输入框样式 */
.el-input__inner {
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  transition: all 0.3s ease;
}

.el-input__inner:focus {
  border-color: #409EFF;
}

/* 选择器样式 */
.el-select .el-input__inner {
  border-radius: 4px;
}

/* 标签样式 */
.el-tag {
  border-radius: 4px;
  font-weight: 500;
}

/* 展开行图标 */
.el-icon-arrow-down,
.el-icon-arrow-right {
  color: #409EFF;
  font-size: 14px;
  transition: transform 0.3s ease;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .campaign-report {
    padding: 16px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .stat-value {
    font-size: 16px;
  }
}
</style>
